import type { ComponentType } from '@grafikr/components';

const Component: ComponentType = (node) => {
  if (!node.dataset.target) {
    throw new Error(`Node must have a [data-target] attribute`);
  }

  const focusElement = document.querySelector<HTMLElement>(node.dataset.target)!;

  const initScroll = () => {
    const scrollElement = document.querySelector(node.dataset.scrollTo) ?? focusElement;

    if (!scrollElement) return;

    scrollElement.scrollIntoView({
      behavior: 'smooth',
    });
  };

  const init = (event: Event) => {
    if (!focusElement) return;

    event.preventDefault();

    initScroll();

    setTimeout(() => {
      focusElement.dispatchEvent(new Event('focusin', { bubbles: true }));
      focusElement.focus();
    }, 300);
  };

  node.addEventListener('click', init);
};

export default Component;
